import * as Rx from 'rxjs'

import MapObjectCRS from './MapObjectCRS'
import MapObjectView from './MapObjectView'
import PositionInfo from './PositionInfo'
import { Image } from '../../states/WorldState'
import {
  MapObjectEvent,
  isAbsentEvent,
  isLoadDataEvent,
  isPresentEvent
} from '../../io/events'
import { Point } from '../../models/BasicTypes'

export default class ImageView implements MapObjectView {
  readonly id: string
  readonly removed$ = new Rx.BehaviorSubject(false)
  readonly position$ = new Rx.BehaviorSubject<PositionInfo | undefined>(
    undefined
  )
  private readonly container: HTMLElement
  private readonly onPress?: (imageView: ImageView) => void
  private _position: Point | null = null
  private thumbnailURL: string | null = null
  private mapObjectCRS: MapObjectCRS
  private subscription?: Rx.Subscription
  private link: HTMLAnchorElement
  private img: HTMLImageElement
  private present = false
  private load = false

  constructor (
    container: HTMLElement,
    mapObjectCRS: MapObjectCRS,
    id: string,
    onPress?: (imageView: ImageView) => void
  ) {
    this.container = container
    this.mapObjectCRS = mapObjectCRS
    this.id = id
    this.onPress = onPress
  }

  processEvent (event: MapObjectEvent) {
    if (isPresentEvent(event)) {
      this.present = true
      this._position = event.position
      this.updateState()
    } else if (isLoadDataEvent(event)) {
      this.load = true
      this.thumbnailURL = (event.data as Image).thumbnailURL
      this.updateState()
    } else if (isAbsentEvent(event)) {
      this.removed$.next(true)
      // TODO
      this.unmount()
    }
  }

  updateFrame (_elasped: number) {
    // No need for update frame
  }

  updateMapObjectCRS (mapObjectCRS: MapObjectCRS) {
    this.mapObjectCRS = mapObjectCRS
    this.updateState()
  }

  private mount () {
    this.link = document.createElement('a')
    this.link.className = [
      'flex',
      'items-center',
      'justify-center',
      'border',
      'absolute',
      'bg-white',
      'rounded',
      'dialog-footer-buttom',
      'border-box',
      // this special class tells map object layer not to handle the tap
      // event
      'ignore-taps',
    ].join(' ')
    this.link.href = '#'
    this.link.style.width = '64px'
    this.link.style.height = '64px'
    this.link.style.padding = '4px'
    this.link.style.transform = 'translate(-50%, -100%)'
    this.link.style.color = 'black'
    this.link.onclick = this.onClick

    this.img = document.createElement('img') as HTMLImageElement
    this.img.style.width = '100%'
    this.img.style.height = '100%'
    const anyStyle = this.img.style as any
    anyStyle.objectFit = 'contain'

    this.link.appendChild(this.img)

    this.container.appendChild(this.link)

    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    this.subscription = new Rx.Subscription()
  }

  private unmount () {
    if (!this.link) {
      return
    }
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    this.subscription = undefined
    this.container.removeChild(this.link)
  }

  private updateState () {
    if (!this.present || !this.load) {
      return
    }
    if (!this.link) {
      this.mount()
    }
    const { mapObjectCRS } = this
    const position = mapObjectCRS.wanderToRelative(this._position!)
    const zIndex = mapObjectCRS.wanderToZIndex(this._position!)
    this.link.style.left = `${position.x}px`
    this.link.style.top = `${position.y}px`
    this.link.style.zIndex = `${zIndex}`
    this.img.src = this.thumbnailURL!
    this.position$.next({
      base: position,
      // Notice: we shouldn't use these anyway I think
      nameOffset: position,
      dialogueOffset: position
    })
  }

  private onClick = (e: Event) => {
    e.preventDefault()
    if (this.onPress) {
      this.onPress(this)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MapObjects/ImageView.tsx